import * as React from 'react'
import { Button, ButtonProps, Header, Message } from 'semantic-ui-react'
import { ExchangeStoreDeck } from './ExchangeStoreDeck'
import { ExchangeUtils } from './ExchangeUtils'
import { DepositLink } from '../RollItemStore/components/DepositLink'
import { common } from '../../../../utils/common'

interface IExchangeStorePickerProps {
    userInfo: IUser,
    isLoggedIn: boolean,
    selectedItems: IIngotItemInfo[],
    onClickBuyItem: (event: React.MouseEvent<HTMLButtonElement>, data: ButtonProps) => void,
    handleRemoveItem: ICallback2<IIngotItemInfo>
}

export default class ExchangeStorePicker extends React.Component<IExchangeStorePickerProps> {
    render(): JSX.Element | false | null {
        const {selectedItems, onClickBuyItem, handleRemoveItem, isLoggedIn, userInfo} = this.props
        const showDeposit = ExchangeUtils.calculateTotalVnd(selectedItems) > userInfo.amount
        return (
            <div>
                {isLoggedIn &&
                <div>
                    <Header as={'h3'} attached={'top'}>
                        Tổng giá trị: ${ExchangeUtils.calculateTotalCoin(selectedItems).toFixed(2)} ~
                        {ExchangeUtils.calculateTotalVnd(selectedItems).toLocaleString('vn')} đ
                    </Header>
                    <ExchangeStoreDeck
                        onClickItem={handleRemoveItem}
                        items={selectedItems}
                    />
                    {showDeposit &&
                    <DepositLink
                        money={common.showRemainAmount(ExchangeUtils.calculateTotalVnd(selectedItems), userInfo) * -1}
                    />}
                    {!showDeposit && <Button color={'blue'} onClick={onClickBuyItem}>Mua</Button>}
                </div>
                }
                {!isLoggedIn &&
                <Message size={'large'} warning={true}>
                    <Message.Header>
                        Bạn vui lòng đăng nhập để sử dụng chức năng này! <br/>
                        Xin cảm ơn!
                    </Message.Header>
                </Message>
                }
            </div>)
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/modules/ExchangeStore/ExchangeStorePicker.tsx